import script from "./SaleForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SaleForm.vue?vue&type=script&setup=true&lang=js"

import "./SaleForm.vue?vue&type=style&index=0&id=415c21bd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-415c21bd"]])

export default __exports__